import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Postdata } from '../../helpers/api.service';
import HttpService from '../../helpers/httpServices';
import { message } from '../../redux/actions/toastActions';
import { Topbar } from '../../components/include/Topbar';
import { isPermission, isRole } from '../../redux/selectors/authSelector';
import Error403Page from '../ErrorPage';

const Add_stream = () => {
    const [errors, setErrors] = useState({});
    const [loader, setLoader] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const params = useParams();
    const fileInputRef = useRef();
    const [selectedFile, setSelectedFile] = useState(null);
    const permissions = useSelector(isPermission);
    const role = useSelector(isRole)
    console.log("permissions", permissions)
    const isAccessible = role == "schooladmin" || permissions && permissions?.includes('edit_Education') || false;




    const [formData, setFormData] = useState({
        grade: "",
        name: "",
        teacher: "",
        no_of_students: 1,
        teacher_image: "",
        description: "",

    })

    const validate = () => {
        const newErrors = {};
        if (!formData.grade) newErrors.grade = true;
        if (!formData.name) newErrors.name = true;
        if (!formData.no_of_students) newErrors.no_of_students = true;
        if (!formData.teacher) newErrors.teacher = true;
        if (!formData.description) newErrors.description = true;
        // Image validation
        if (!formData.teacher_image) {
            newErrors.teacher_image = "Teacher image is required";
        } else if (
            typeof formData.teacher_image !== "string" &&
            formData.teacher_image.size > 10 * 1024 * 1024
        ) {
            newErrors.teacher_image = "Image must be less than 10MB";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!validate()) return;
        setLoader(true);

        const form = new FormData();
        if (params.id) form.append("id", params.id);
        form.append("grade", formData.grade);
        form.append("name", formData.name);
        form.append("no_of_students", formData.no_of_students);
        form.append("teacher", formData.teacher);
        form.append("description", formData.description);
        form.append("teacher_image", formData.teacher_image);


        Postdata(HttpService.stream_add, form).then((res) => {
            if (res.status === 200) {
                navigate(`/education`, {
                    replace: true,
                    state: { currentTab: "Streams" },
                });
            }
            dispatch(message(res.message));
            setLoader(false)
        });
        console.log("Submitted as FormData:", formData);
    }

    const fetchData = () => {
        setLoader(true)
        Postdata(HttpService.stream_show, { id: params.id }).then((res) => {
            if (res.status === 200) {
                setFormData({
                    grade: res.data.grade,
                    no_of_students: res.data.no_of_students,
                    name: res.data.name,
                    description: res.data.description,
                    teacher: res.data.teacher,
                    teacher_image: res.data.teacher_image,
                })
            } else {

                dispatch(message(res.message));
            }
        });
        setLoader(false)
    }

    useEffect(() => {
        if (location.state?.type === "edit") {
            fetchData()
        }
    }, [])

    if (!isAccessible) {
        return (
            <>
                <Error403Page />
            </>
        );
    }

    return (
        <>
            <Topbar title={location.state?.type == "edit" ? "Edit Stream" : "Add Stream"} aerrow={true} />

            <div className="p-6 bg-gray-100 min-h-screen">
                <form onSubmit={(e) => handleSubmit(e)}>


                    {/* Inline Inputs */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                        {/* Performance Year */}
                        <div>
                            <label className="block mb-1 font-medium text-gray-700">
                                Grade <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="text"
                                name="grade"
                                placeholder="Enter Grade"
                                className="input-field"
                                value={formData.grade}
                                onChange={handleInputChange}
                            />
                            {errors.grade && (
                                <span className="text-red-500 text-sm">Grade Required</span>
                            )}
                        </div>

                        <div>
                            <label className="block mb-1 font-medium text-gray-700">
                                Stream Name<span className="text-red-500">*</span>
                            </label>
                            <input
                                type="text"
                                name="name"
                                placeholder="Enter Stream Name"
                                className="input-field"
                                value={formData.name}
                                onChange={handleInputChange}
                            />
                            {errors.name && (
                                <span className="text-red-500 text-sm">Name Required</span>
                            )}
                        </div>
                        <div>
                            <label className="block mb-1 font-medium text-gray-700">
                                Average Number of Students<span className="text-red-500">*</span>
                            </label>
                            <input
                                type="number"
                                name="no_of_students"
                                placeholder="Enter Number of Students"
                                className="input-field"
                                value={formData.no_of_students}
                                onChange={handleInputChange}
                                max={100}
                                min={1}
                            />
                            {errors.no_of_students && (
                                <span className="text-red-500 text-sm">Average Number of Students Required</span>
                            )}
                        </div>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                        <div>
                            <label className="block mb-1 font-medium text-gray-700">
                                Stream Class Teacher<span className="text-red-500">*</span>
                            </label>
                            <input
                                type="text"
                                name="teacher"
                                placeholder="Enter Stream Class Teacher"
                                className="input-field"
                                value={formData.teacher}
                                onChange={handleInputChange}
                            />
                            {errors.teacher && (
                                <span className="text-red-500 text-sm">Teacher Required</span>
                            )}
                        </div>
                        <div className="mt-2">
                            <label className="block mb-1 font-medium text-gray-700">
                                Class Teacher Image<span className="text-red-500">*</span>
                            </label>
                            <div className="relative flex-1">
                                <input
                                    type="text"
                                    placeholder="Select Image"
                                    className="input-field"
                                    readOnly
                                //   value={pdfFile?.name || ""}
                                />
                                <button
                                    type="button"
                                    onClick={() => fileInputRef.current.click()}
                                    className="absolute top-1/2 right-3 -translate-y-1/2 text-orange-600 font-semibold"
                                >
                                    Upload
                                </button>
                            </div>
                            {errors.teacher_image && (
                            <span className="text-red-500 text-sm">{errors.teacher_image}</span>
                        )}
                            {/* Hidden File Input */}
                            <input
                                type="file"
                                ref={fileInputRef}
                                name="file"
                                accept=".jpg,.jpeg,.png"
                                onChange={(e) => {
                                    const file = e.target.files[0];
                                    const maxSize = 10 * 1024 * 1024; // 10 MB

                                    if (file) {
                                        if (file.size > maxSize) {
                                            setErrors((prev) => ({
                                                ...prev,
                                                teacher_image: "Image must be less than 10MB"
                                            }));
                                            e.target.value = ""; // reset input
                                            return;
                                        } else {
                                            setErrors((prev) => ({ ...prev, teacher_image: "" }));
                                            setFormData({ ...formData, teacher_image: file });
                                        }
                                    }
                                }}
                                className="hidden"
                            />
                        </div>
                        
                        <div className="flex gap-[14px] mt-3">
                            {console.log("selectedFile", selectedFile)}
                            {formData.teacher_image && (
                                <div
                                    className="relative rounded-md flex items-center justify-center"
                                >
                                    <img
                                        src={
                                            typeof formData.teacher_image === "string"
                                                ? formData.teacher_image
                                                : URL.createObjectURL(formData.teacher_image)
                                        }
                                        alt="Selected"
                                        className="w-20 h-20 object-cover  rounded-full "
                                    />
                                    <button
                                        type="button"
                                        onClick={() => setFormData({ ...formData, teacher_image: "" })}
                                        className="absolute -top-2 -right-2 bg-black text-white rounded-full w-5 h-5 text-xs flex items-center justify-center hover:bg-gray-800"
                                    >
                                        ✕
                                    </button>
                                </div>
                            )}
                        </div>

                    </div>
                    <div>
                        <label className="block mb-1 font-medium text-gray-700">
                            Description<span className="text-red-500">*</span>
                        </label>
                        <textarea
                            name="description"
                            placeholder="Write Here"
                            className="input-field"
                            value={formData.description}
                            onChange={handleInputChange}
                        />
                        {errors.description && (
                            <span className="text-red-500 text-sm">Description Required</span>
                        )}
                    </div>

                    <div className="w-full flex justify-center gap-3 mb-2 mt-4">
                        <button
                            type="submit"
                            className="button-field-primary"
                            style={{ width: "30%" }}
                            disabled={loader}
                        >
                            {loader ? 'Please wait...' : ('Submit')}
                        </button>
                    </div>
                </form>
            </div>
        </>
    )
}

export default Add_stream